//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-vertical-wrapper',
  props: {
    columnGap: {
      type: Number,
      default: 1,
    },
    spaceBetweenSlides: {
      type: Number,
      default: 8,
    },
  },
}
